import { ethers } from 'ethers';
import DecentralizedKYCSystemABI from './DecentralizedKYCSystem.json';
import MarketplaceERC721ABI from './MarketplaceERC721.json';
import MarketplaceERC1155ABI from './MarketplaceERC1155.json';
import VipcardERC721ABI from './VipcardERC721.json';
import CommunityTokenABI from './CommunityToken.json';
import { CommunityToken,MarketplaceERC1155,MarketplaceERC721,DecentralizedKYCSystem,VipcardERC721 } from './contracts-address';
// Permission Enum
export enum ChainId {
  ETH = 1,
  Base = 8453, 
  Basesepolia = 84532,
  Polygon = 137, 
  Sepolia = 11155111,
  Amoy = 80002,
  Optimism = 10,
  Optimismsepolia = 11155420,
  Arbitrum = 42161,
  Arbitrumsepolia = 421614,
}
export enum Permission {
  NONE = 0,
  READ_ONLY = 1,
  READ_WRITE = 2
}

// Permission Labels
export const PERMISSION_LABELS = {
  [Permission.NONE]: 'No Permission',
  [Permission.READ_ONLY]: 'Read Only',
  [Permission.READ_WRITE]: 'Read Write'
};

// Permission Colors
export const PERMISSION_COLORS = {
  [Permission.NONE]: 'default' as const,
  [Permission.READ_ONLY]: 'primary' as const,
  [Permission.READ_WRITE]: 'success' as const
};
// KYC审核状态枚举
export enum KYCStatus {
  NONE = 0,
  PENDING = 1,
  APPROVED = 2,
  REJECTED = 3
}

// KYC状态标签
export const KYC_STATUS_LABELS = {
  [KYCStatus.NONE]: 'Not Minted',
  [KYCStatus.PENDING]: 'Pending',
  [KYCStatus.APPROVED]: 'Approved',
  [KYCStatus.REJECTED]: 'Rejected'
};

// KYC状态颜色
export const KYC_STATUS_COLORS = {
  [KYCStatus.NONE]: 'default' as const,
  [KYCStatus.PENDING]: 'warning' as const,
  [KYCStatus.APPROVED]: 'success' as const,
  [KYCStatus.REJECTED]: 'error' as const
};

// 网络配置
export const NETWORKS = {
  POLYGON_MAINNET: {
    chainId: 137,
    name: 'Polygon Mainnet',
    rpcUrl: 'https://polygon-rpc.com/',
    rpcUrls: [
      'https://polygon-rpc.com/',
      'https://rpc-mainnet.matic.network/',
      'https://polygon-mainnet.public.blastapi.io/'
    ],
    blockExplorerUrl: 'https://polygonscan.com/',
    nativeCurrency: {
      name: 'POL',
      symbol: 'POL',
      decimals: 18
    }
  },
  // POLYGON_AMOY: {
  //   chainId: 80002,
  //   name: 'Polygon Amoy Testnet',
  //   rpcUrl: 'https://polygon-amoy-bor-rpc.publicnode.com/',
  //   rpcUrls: [
  //     'https://polygon-amoy-bor-rpc.publicnode.com',
  //     'https://rpc.ankr.com/polygon_amoy',
  //     'https://rpc-amoy.polygon.technology/',
  //     'https://polygon-amoy-bor-rpc.publicnode.com/',
  //     'https://polygon-amoy.drpc.org/'
  //   ],
  //   blockExplorerUrl: 'https://amoy.polygonscan.com/',
  //   nativeCurrency: {
  //     name: 'POL',
  //     symbol: 'POL',
  //     decimals: 18
  //   }
  // }
};

// 合约地址配置
export const CONTRACT_ADDRESSES = {
  [NETWORKS.POLYGON_MAINNET.chainId]: { 
    DecentralizedKYCSystem: DecentralizedKYCSystem ,
    CommunityToken: CommunityToken ,
    MarketplaceERC1155: MarketplaceERC1155 ,
    MarketplaceERC721: MarketplaceERC721 ,
    VipcardERC721: VipcardERC721
  }, 
  // [NETWORKS.POLYGON_AMOY.chainId]: { 
  //   DecentralizedKYCSystem: '0x2882ACcc6617F108C63776aF29323166E122E09A' // 需要部署后更新
  // } 
};
export const ZEROEX_NATIVE_TOKEN_ADDRESS =
  '0x0000000000000000000000000000000000000000';

// export const ZEROEX_NATIVE_TOKEN_ADDRESS =
//   '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee';

export const MULTICALL_NATIVE_TOKEN_ADDRESS =
  '0x0000000000000000000000000000000000000000';
// 合约ABI
// DecentralizedKYCSystem 合约 ABI
export const DECENTRALIZED_KYC_SYSTEM_ABI = DecentralizedKYCSystemABI;

export const ERC721Abi = [
  'function name() external view returns (string _name)',
  'function symbol() external view returns (string _symbol)',
  'function ownerOf(uint256 _tokenId) view returns (address)',
  'function balanceOf(address _owner) view returns (uint256 balance)',
  'function tokenURI(uint256 _tokenId) view returns (string)',
  'function contractURI() view returns (string)', 
];

export const ERC1155Abi = [
  'function name() external view returns (string _name)',
  'function symbol() external view returns (string _symbol)',
  'function uri(uint256 _tokenId) view returns (string)',
  'function balanceOf(address _account, uint256 _id) public view returns (uint256 balance)',
  'function contractURI() view returns (string)', 
];

export const ERC20Abi = [
  'function name() public view returns (string)',
  'function symbol() public view returns (string)',
  'function decimals() public view returns (uint8)',
  'function totalSupply() public view returns (uint256)',
  'function balanceOf(address _owner) public view returns (uint256 balance)',
  'function transfer(address _to, uint256 _value) public returns (bool success)',
  'function transferFrom(address _from, address _to, uint256 _value) public returns (bool success)',
  'function approve(address _spender, uint256 _value) public returns (bool success)',
  'function allowance(address _owner, address _spender) public view returns (uint256 remaining)',
  'event Transfer(address indexed _from, address indexed _to, uint256 _value)',
  'event Approval(address indexed _owner, address indexed _spender, uint256 _value)',
];

export const WETHAbi = [
  ...ERC20Abi,
  'function deposit() public payable',
  'function withdraw(uint wad) public',
]; 

// 创建带重试机制的Provider
export const createProviderWithFallback = async (chainId: number): Promise<ethers.providers.JsonRpcProvider> => {
  const network = chainId === NETWORKS.POLYGON_MAINNET.chainId ? NETWORKS.POLYGON_MAINNET : NETWORKS.POLYGON_MAINNET;
  
  for (const rpcUrl of network.rpcUrls) {
    try {
      const provider = new ethers.providers.JsonRpcProvider(rpcUrl, {
        chainId: network.chainId,
        name: network.name
      });
      
      // 测试连接
      await provider.getNetwork();
      console.log(`成功连接到RPC: ${rpcUrl}`);
      return provider;
    } catch (error) {
      console.warn(`RPC连接失败 ${rpcUrl}:`, error);
      continue;
    }
  }
  
  throw new Error(`无法连接到${network.name}的任何RPC节点，请检查网络连接`);
};

// 验证合约是否存在
export const validateContract = async (contractAddress: string, provider: ethers.providers.Provider): Promise<boolean> => {
  try {
    // 首先检查地址格式
    if (!ethers.utils.isAddress(contractAddress)) {
      console.warn('无效的合约地址格式:', contractAddress);
      return false;
    }
    
    // 如果是零地址，直接返回 false
    if (contractAddress === '0x0000000000000000000000000000000000000000') {
      console.warn('合约地址为零地址');
      return false;
    }
    
    // Attempt to get contract code, with retry mechanism
    const code = await callContractWithRetry(async () => {
      return await provider.getCode(contractAddress);
    });
    
    const isValid = code !== '0x';
    if (!isValid) {
      console.warn('No code deployed at contract address:', contractAddress);
    }
    
    return isValid;
  } catch (error: any) {
    console.error('Contract verification failed:', error);
    
    // For MetaMask RPC errors, we assume the contract exists and let subsequent calls handle it
    if (error.code === -32603 || error.message?.includes('Internal JSON-RPC error')) {
      console.warn('RPC verification failed, skipping contract verification step');
      return true; // Assume contract exists, let subsequent calls handle it
    }
    
    return false;
  }
};

// // Get contract instance
// export const getContract = (chainId: number, provider: ethers.providers.Provider) => {
//   const contractAddress = CONTRACT_ADDRESSES[chainId]?.DecentralizedKYCSystem;
//   if (!contractAddress || contractAddress === '0x0000000000000000000000000000000000000000') {
//     throw new Error('DecentralizedKYCSystem contract not yet deployed to the current network, please contact administrator or switch to a network with deployed contract');
//   }
//   return new ethers.Contract(contractAddress, DECENTRALIZED_KYC_SYSTEM_ABI, provider);
// };

// // Get contract instance with signer
// export const getContractWithSigner = (chainId: number, signer: ethers.Signer) => {
//   const contractAddress = CONTRACT_ADDRESSES[chainId]?.DecentralizedKYCSystem;
//   if (!contractAddress || contractAddress === '0x0000000000000000000000000000000000000000') {
//     throw new Error('DecentralizedKYCSystem contract not yet deployed to the current network, please contact administrator or switch to a network with deployed contract');
//   }
//   return new ethers.Contract(contractAddress, DECENTRALIZED_KYC_SYSTEM_ABI, signer);
// };

// DecentralizedKYCSystem contract instance acquisition function
export const getKYCContract = (chainId: number, provider: ethers.providers.Provider) => {
  const contractAddress = CONTRACT_ADDRESSES[chainId]?.DecentralizedKYCSystem;
  if (!contractAddress || contractAddress === '0x0000000000000000000000000000000000000000') {
    throw new Error('DecentralizedKYCSystem contract not yet deployed to the current network, please contact administrator or switch to a network with deployed contract');
  }
  return new ethers.Contract(contractAddress, DecentralizedKYCSystemABI, provider);
};

export const getKYCContractWithSigner = (chainId: number, signer: ethers.Signer) => {
  const contractAddress = CONTRACT_ADDRESSES[chainId]?.DecentralizedKYCSystem;
  if (!contractAddress || contractAddress === '0x0000000000000000000000000000000000000000') {
    throw new Error('DecentralizedKYCSystem contract not yet deployed to the current network, please contact administrator or switch to a network with deployed contract');
  }
  return new ethers.Contract(contractAddress, DecentralizedKYCSystemABI, signer);
};

export const getreadContract = (addressname:string,chainId: number, provider: ethers.providers.Provider) => { 
  const contractAddress = getContractAddressbyname(addressname,chainId);
   const contractabi =  getContractABIbyname(addressname,chainId);
  if (!contractAddress || contractAddress === '0x0000000000000000000000000000000000000000'||!contractabi) {
    throw new Error(addressname+' contract not yet deployed to the current network, please contact administrator or switch to a network with deployed contract');
  }
  return new ethers.Contract(contractAddress, contractabi, provider);
};

export const getwriteContractWithSigner = (addressname:string,chainId: number, signer: ethers.Signer) => {
 const contractAddress = getContractAddressbyname(addressname,chainId);
 const contractabi =  getContractABIbyname(addressname,chainId);
  if (!contractAddress || contractAddress === '0x0000000000000000000000000000000000000000'||!contractabi) {
    throw new Error(addressname+' contract not yet deployed to the current network, please contact administrator or switch to a network with deployed contract');
  }
  return new ethers.Contract(contractAddress, contractabi, signer);
};
// Helper function to get contract address by name
export const getContractAddressbyname = (addressname:string,chainId: number): string => {
    //CommunityToken: CommunityToken ,
   // MarketplaceERC1155: MarketplaceERC1155 ,
   // MarketplaceERC721: MarketplaceERC721 ,
   // VipcardERC721: VipcardERC721
  let contractAddress = "0x0000000000000000000000000000000000000000" ; 
  if (addressname=='DecentralizedKYCSystem') {
      contractAddress = CONTRACT_ADDRESSES[chainId]?.DecentralizedKYCSystem;
    }else if(addressname=='CommunityToken'){
      contractAddress = CONTRACT_ADDRESSES[chainId]?.CommunityToken;
    }else if(addressname=='VipcardERC721'){
      contractAddress = CONTRACT_ADDRESSES[chainId]?.VipcardERC721;
    }else if(addressname=='MarketplaceERC721'){
      contractAddress = CONTRACT_ADDRESSES[chainId]?.MarketplaceERC721;
    }else if(addressname=='MarketplaceERC1155'){
      contractAddress = CONTRACT_ADDRESSES[chainId]?.MarketplaceERC1155;
    }  
  return contractAddress;
};
// Helper function to get contract ABI by name
export const getContractABIbyname = (addressname:string,chainId: number): any => {
    //CommunityToken: CommunityToken ,
   // MarketplaceERC1155: MarketplaceERC1155 ,
   // MarketplaceERC721: MarketplaceERC721 ,
   // VipcardERC721: VipcardERC721
  let contractABI:any; 
  if (addressname=='DecentralizedKYCSystem') {
      contractABI = DecentralizedKYCSystemABI;
    }else if(addressname=='CommunityToken'){
      contractABI = CommunityTokenABI;
    }else if(addressname=='VipcardERC721'){
      contractABI = VipcardERC721ABI;
    }else if(addressname=='MarketplaceERC721'){
      contractABI =  MarketplaceERC721ABI;
    }else if(addressname=='MarketplaceERC1155'){
      contractABI =  MarketplaceERC1155ABI;
    }  
  return contractABI;
};


// Compatible with old getContract function, now points to DecentralizedKYCSystem
export const getContract = getKYCContract;
export const getContractWithSigner = getKYCContractWithSigner;

// Helper function to get KYC contract address
export const getKYCContractAddress = (chainId: number): string => {
  const contractAddress = CONTRACT_ADDRESSES[chainId]?.DecentralizedKYCSystem;
  if (!contractAddress || contractAddress === '0x0000000000000000000000000000000000000000') {
    throw new Error('DecentralizedKYCSystem contract not yet deployed to the current network, please contact administrator or switch to a network with deployed contract');
  }
  return contractAddress;
};

// Check if KYC contract is deployed
export const isKYCContractDeployed = (chainId: number): boolean => {
  const contractAddress = CONTRACT_ADDRESSES[chainId]?.DecentralizedKYCSystem;
  return !!(contractAddress && contractAddress !== '0x0000000000000000000000000000000000000000');
};

// Contract call with retry mechanism
export const callContractWithRetry = async <T>(
  contractCall: () => Promise<T>,
  maxRetries: number = 3,
  delay: number = 1000
): Promise<T> => {
  let lastError: any;
  
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await contractCall();
    } catch (error: any) {
      lastError = error;
      console.warn(`Contract call failed (attempt ${i + 1}/${maxRetries}):`, error.message);
      
      // If it's the last attempt, throw the error directly
      if (i === maxRetries - 1) {
        break;
      }
      
      // Wait and retry
      await new Promise(resolve => setTimeout(resolve, delay * (i + 1)));
    }
  }
  
  // Handle specific error types
  if (lastError?.code === 'CALL_EXCEPTION') {
    if (lastError.message.includes('missing trie node')) {
      throw new Error('Blockchain node state unavailable, please try again later or switch networks');
    } else if (lastError.message.includes('revert')) {
      throw new Error('Contract call rejected, please check parameters or permissions');
    }
  }
  
  throw lastError;
};

// Check if it is a supported network
export const isSupportedNetwork = (chainId: number): boolean => {
  return chainId === NETWORKS.POLYGON_MAINNET.chainId;
};

 

// Error handling utility function
// Polygon Gas Station API to get gas fees
export const getPolygonGasFees = async (chainId: number): Promise<{ maxFeePerGas: string; maxPriorityFeePerGas: string } | null> => {
  try {
    let gasStationUrl: string;
    
    if (chainId === NETWORKS.POLYGON_MAINNET.chainId) {
      gasStationUrl = 'https://gasstation.polygon.technology/v2';
    } else if (chainId === 80002) {
      gasStationUrl = 'https://gasstation.polygon.technology/amoy';
    } else {
      console.warn('Unsupported network, unable to get Polygon gas fees');
      return null;
    }
    
    const response = await fetch(gasStationUrl);
    if (!response.ok) {
      throw new Error(`Gas Station API request failed: ${response.status}`);
    }
    
    const data = await response.json();
    
    // Use standard level fees and convert to wei
    const maxFeePerGas = ethers.utils.parseUnits(data.standard.maxFee.toString(), 'gwei');
    const maxPriorityFeePerGas = ethers.utils.parseUnits(data.standard.maxPriorityFee.toString(), 'gwei');
    
    console.log('Polygon Gas fees obtained successfully:', {
      maxFeePerGas: maxFeePerGas.toString(),
      maxPriorityFeePerGas: maxPriorityFeePerGas.toString()
    });
    
    return {
      maxFeePerGas: maxFeePerGas.toString(),
      maxPriorityFeePerGas: maxPriorityFeePerGas.toString()
    };
  } catch (error) {
    console.error('Failed to get Polygon gas fees:', error);
    return null;
  }
};

export const handleContractError = (error: any): string => {
  console.error('Contract error details:', error);
  
  // MetaMask RPC internal error handling
  if (error?.code === -32603 || error?.message?.includes('Internal JSON-RPC error')) {
    return 'MetaMask internal error, please try the following solutions:\n• Refresh the page to reconnect the wallet\n• Check network connection status\n• Switch to another RPC node\n• Restart MetaMask extension';
  }
  
  // User rejected transaction
  if (error?.code === 4001 || error?.message?.includes('User denied')) {
    return 'User cancelled the transaction';
  }
  
  // Gas fee related errors
  if (error?.code === -32000 || error?.message?.includes('insufficient funds')) {
    return 'Insufficient account balance, please ensure you have enough Gas fees';
  }
  
  if (error?.code === 'CALL_EXCEPTION') {
    if (error.message.includes('missing trie node')) {
      return 'Blockchain node state unavailable, please try again later or switch to another network';
    } else if (error.message.includes('revert')) {
      return 'Contract call rejected, please check parameters or permissions';
    } else if (error.message.includes('INSUFFICIENT_FUNDS')) {
      return 'Insufficient account balance, please ensure you have enough Gas fees';
    }
  } else if (error?.code === 'NETWORK_ERROR') {
    return 'Network connection error, please check network connection or switch RPC node';
  } else if (error?.code === 'TIMEOUT') {
    return 'Request timed out, please try again later';
  }
  
  return error?.message || 'Unknown error, please try again later';
};


// Contract Factory Class - Provides better contract instance management
export class KYCContractFactory {
  private static instance: KYCContractFactory;
  private contractCache: Map<string, ethers.Contract> = new Map();
  
  private constructor() {}
  
  public static getInstance(): KYCContractFactory {
    if (!KYCContractFactory.instance) {
      KYCContractFactory.instance = new KYCContractFactory();
    }
    return KYCContractFactory.instance;
  }
  
  // Get read-only contract instance
   public getReadOnlyContract(chainId: number, provider: ethers.providers.Provider): ethers.Contract | null {
     if (!isKYCContractDeployed(chainId)) {
       console.warn(`KYC contract not deployed to network ${chainId}`);
       return null;
     }
     
     // Use chainId and provider type as cache key
     const providerType = provider.constructor.name || 'Provider';
     const cacheKey = `readonly-${chainId}-${providerType}`;
     
     if (!this.contractCache.has(cacheKey)) {
       try {
         const contract = getKYCContract(chainId, provider);
         this.contractCache.set(cacheKey, contract);
       } catch (error) {
         console.error('Failed to create read-only contract instance:', error);
         return null;
       }
     }
     
     return this.contractCache.get(cacheKey) || null;
   }
  
  // Get writable contract instance (requires signer)
  public getWritableContract(chainId: number, signer: ethers.Signer): ethers.Contract | null {
    if (!isKYCContractDeployed(chainId)) {
      console.warn(`KYC contract not deployed to network ${chainId}`);
      return null;
    }
    
    try {
      // Do not cache writable contracts, as signer may change
      return getKYCContractWithSigner(chainId, signer);
    } catch (error) {
      console.error('Failed to create writable contract instance:', error);
      return null;
    }
  }
  
  // Clear cache
  public clearCache(): void {
    this.contractCache.clear();
  }
  
  // Clear cache for specific network
  public clearCacheForChain(chainId: number): void {
    const keysToDelete = Array.from(this.contractCache.keys())
      .filter(key => key.includes(`-${chainId}-`));
    
    keysToDelete.forEach(key => {
      this.contractCache.delete(key);
    });
  }
}

// Export singleton instance
export const contractFactory = KYCContractFactory.getInstance();

// Convenience function - Recommended for use in React hooks
export const createKYCContract = {
  // Create read-only contract instance
  readOnly: (chainId: number, provider: ethers.providers.Provider) => {
    return contractFactory.getReadOnlyContract(chainId, provider);
  },
  
  // Create writable contract instance
  writable: (chainId: number, signer: ethers.Signer) => {
    return contractFactory.getWritableContract(chainId, signer);
  }
};